// extracted by mini-css-extract-plugin
export default {"notFound":"notFound_notFound__x7TWt","notFound_title":"notFound_notFound_title__QQL3d","notFound_desc":"notFound_notFound_desc__gtoGb","Shimiring":"notFound_Shimiring__8KGr5"};